import { theme } from "../../utils/theme";

import contact_section from "../../assets/background/contact_section_bg.jpg";

export const styles = {
  background: {
    background: `url(${contact_section})`,
    backgroundColor: theme.palette.primary.main,
    backgroundPosition: "left bottom !important",
    backgroundRepeat: "no-repeat !important",
    backgroundSize: "cover !important",
    filter: "brightness(1.2) grayscale(0.3)",
    height: "100%",
    left: { xs: 0, sm: 0 },
    top: { xs: 0, sm: 0 },
    position: "absolute",
    width: { xs: "220%", sm: "120%" },
    zIndex: -2,
  },
  body: {
    alignItems: "center",
    display: "flex",
    justifyContent: "start",
    position: "relative",
  },
  bodyText: {
    color: theme.palette.grays[900],
    fontSize: theme.typography.body,
    fontWeight: 300,
    textAlign: { xs: "center", md: "center" },
    textTransform: "none",
  },
  button: {
    backgroundColor: theme.palette.grays["white"],
    color: theme.palette.grays[900],
    minWidth: 200,
    "&:hover": {
      backgroundColor: theme.palette.grays[200],
    },
  },
  contactCard: {
    alignItems: "center",
    borderRadius: 8,
    // boxShadow: "0 0 24px rgba(37,43,129,.04), 0 44px 74px rgba(37,43,129,.06)",
    overflow: "hidden",
    px: 0,
    py: 12,
    position: "relative",
    width: "100%",
  },
  contactRoot: {
    alignItems: { xs: "center", md: "center" },
    justifyContent: "center",
    width: "100%",
  },
  grow: {
    flexGrow: 1,
    marginLeft: "auto",
  },
  margin: {
    display: "flex",
    margin: 1,
  },
};
